export default __webpack_public_path__ + "static/media/problema-03.d2da3a61.webp";